import React from 'react';
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import ScrollToTop from "react-scroll-to-top";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import Logo from "../../assets/img/logo.png";
import clogo from "../../assets/img/clogo.png";
// import android from "../../assets/img/1.png";
// import iphone from "../../assets/img/2.png";

import {android,iphone } from '../../constants/Images';


const Footer = () => {
 return (
     <>   
    <footer>
        <div className="footer-bottom">
            {/* <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 footer-icon">

                          <ul>
                             <li><a href="https://www.facebook.com/superplayerauction" target="_blank"><AiIcons.AiFillFacebook></AiIcons.AiFillFacebook></a></li>
                             <li><a href="#" target="_blank"><AiIcons.AiFillInstagram></AiIcons.AiFillInstagram></a></li>
                             <li><a href="https://youtu.be/vCcppfCmlaQ" target="_blank"><IoIcons.IoLogoYoutube></IoIcons.IoLogoYoutube></a></li>
                             </ul><ul><li><a href="https://play.google.com/store/apps/details?id=com.harshtechnology.player_auction" target="_blank">
                       <img src={android} className="" alt="android"/>
                    </a></li>
                    <li><a className="" href="https://apps.apple.com/us/app/super-player-auction/id1472722558" target="_blank"> 
                    <img src={iphone} className="" alt="iphone"/></a></li>
                           </ul>

                        <div className="col-md-12 footer-icon-p">
                            <p>&copy;  Copyright Super Player Auction . All Rights Reserved</p>
                        </div>
                   
                    </div>
                </div>

            </div> */}

        <div className="foot-flex">
          <div className='foot-part fpart1'>
            {/* <h3>About Us</h3> */}
            <h4 className='foot-head'>                                    <img src={Logo} className="logo" alt="Super player auction logo" />
            </h4>
            <p style={{ opacity: '.7' }}>------------ Powered By -------------</p>
            <h4 className='f-textcenter'><a target='_blank' href="http://harshtechnology.com" style={{ textDecoration: 'none' }}> <img src={clogo} alt="jj" className='clogo' /><span className='f-c-name'> Harsh Technology</span></a></h4>


          </div>
          <div className='foot-part'>
            <h3>GET APP</h3>
            <ul className='download-links'>
              <li><a href="https://play.google.com/store/apps/details?id=com.harshtechnology.player_auction" target="_blank">
                <img src={android} alt="android" />
              </a>
              </li>
              <li>
                <a className="" href="https://apps.apple.com/us/app/super-player-auction/id1472722558" target="_blank">
                  <img src={iphone} className="" alt="iphone" />
                </a>
              </li>
            </ul>
          </div>

          <div className='foot-part'>
            <h3>QUICK LINKS</h3>
            <p><a href="/#our-clients"><span className='f-s-name' >Our Clients</span></a></p>
            <p><a href="/pricing"><span className='f-s-name' >Our Pricing</span></a></p>

            {/* <p>FAQ</p> */}
          </div>
          <div className='foot-part'>
            <h3>CONTACT US</h3>
            <p><CiMail className='f-e-icons' /> &nbsp; superauctionapp@gmail.com</p>
            <p><IoCallOutline className='f-e-icons' />&nbsp;+91-83860-11123</p>
            <p><IoCallOutline className='f-e-icons' />&nbsp;+91-73750-11123</p>
          </div>
          <div className='foot-part'>
            <h3>FIND US ON</h3>
            <p><a href="https://www.facebook.com/superplayerauction" target="_blank"><AiIcons.AiFillFacebook></AiIcons.AiFillFacebook><span className='f-s-name'> Facebook </span></a></p>
            <p><a href="#" target="_blank"><AiIcons.AiFillInstagram></AiIcons.AiFillInstagram> <span className='f-s-name'>Instagram</span></a></p>
            <p><a href="" target="_blank"><IoIcons.IoLogoYoutube ></IoIcons.IoLogoYoutube><span className='f-s-name'> You-Tube</span></a></p>

          </div>

        </div>
        <div className='policy-container'>
          <div className='policies'>
            <div><a target="_blank" href="https://superplayerauction.com/policy/tnc.html">Terms and Conditions</a></div>
            <div><a target="_blank" href="https://superplayerauction.com/policy/privacypolicy.html">Privacy policy</a></div>
            <div><a target="_blank" href="https://superplayerauction.com/policy/refund.html">Refund Policy</a></div>
          </div>
        </div>
        <div className="f-l-part">
          &copy; Copyright Super Player Auction | All Rights Reserved
        </div>
        </div>
    </footer>  

    <ScrollToTop smooth></ScrollToTop>    

    </> 
    )
}

export default Footer
